import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { SelectOption, SelectProps } from '@ui';

// constants
import { AccountUserPermissionTypes } from 'enums/onboarding/crm';

// components
import { FormSelect } from '@ui';

export type IProps = SelectProps;

const AccountPermissionSelect = (props: IProps) => {
  const { t } = useTranslation(['onboarding', 'form']);

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(AccountUserPermissionTypes).map((key) => ({
        id: key,
        label: t(`personal_info_modal.account_permission_types.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default AccountPermissionSelect;
